import request from "@/utils/request";
export function getOnlineInfo(query) {
  return request({
    url: "/portal/new/",
    method: "get",
    params: query,
  });
}
//上链企业
export function getsupplier() {
  return request({
    url: "/portal/supplier/",
    method: "get",
  });
}
//上链合同
export function getcontract() {
  return request({
    url: "/portal/contract/",
    method: "get",
  });
}
//上链权证
export function getcertificate() {
  return request({
    url: "/portal/certificate/",
    method: "get",
  });
}
//融资总额度
export function getReceipt() {
  return request({
    url: "/portal/receipt/",
    method: "get",
  });
}

export function getNews(query) {
  return request({
    url: "/api/news/",
    method: "get",
    params: query,
  });
}
export function getuploadImg(id) {
  return request({
    url: '/api/avatar/'+id+'/',
    method: 'get',
  })
}
export function getNewsDetailById(id) {
  return request({
    url: '/api/news/' + id + '/',
    method: "put",
  });
}
//根据文章类型查询文章
export function getNewsByType(query) {
  return request({
    url: "/api/news/list_by_type/",
    method: "get",
    params: query,
  });
}
//获取文章类型
export function getNewTypeList() {
  return request({
    url: '/api/new_type/',
    method: 'get'
  })
}
//数据配置
export function initData() {
  return request({
    url: '/api/num/',
    method: 'get'
  })
}
/*
*旧版接口
*/
export function login(data) {
  return request({
    url: "/api/login/",
    method: "post",
    data,
  });
}
export function getGyl(query) {
  return request({
    url: "/portal/gyl/",
    method: "get",
    params: query,
  });
}
export function getSupplier(query) {
  return request({
    url: "/portal/supplier/",
    method: "get",
    params: query,
  });
}
export function getContract(query) {
  return request({
    url: "/portal/contract/",
    method: "get",
    params: query,
  });
}
export function getInvoice(query) {
  return request({
    url: "/portal/invoice/",
    method: "get",
    params: query,
  });
}
export function getCertificate(query) {
  return request({
    url: "/portal/certificate/",
    method: "get",
    params: query,
  });
}
export function getBlockheight(query) {
  return request({
    url: "/portal/blockheight/",
    method: "get",
    params: query,
  });
}
export function getBlocktime(query) {
  return request({
    url: "/portal/blocktime/",
    method: "get",
    params: query,
  });
}
export function getTotaldatavolume(query) {
  return request({
    url: "/portal/totaldatavolume/",
    method: "get",
    params: query,
  });
}
export function getDatavolumeinthelastthreedays(query) {
  return request({
    url: "/portal/datavolumeinthelastthreedays/",
    method: "get",
    params: query,
  });
}
export function getNumberofaddresses(query) {
  return request({
    url: "/portal/numberofaddresses/",
    method: "get",
    params: query,
  });
}
export function getDatavolumeinthelastthirtydays(query) {
  return request({
    url: "/portal/datavolumeinthelastthirtydays/",
    method: "get",
    params: query,
  });
}
export function getDatavolumeinthelastthirtycontracts(query) {
  return request({
    url: "/portal/datavolumeinthelastthirtycontracts/",
    method: "get",
    params: query,
  });
}


// old
export function getChainInfo(query) {
  return request({
    url: "/api/chain/info",
    method: "get",
    params: query,
  });
}
export function getChainCharts(query) {
  return request({
    url: "/api/chain/charts",
    method: "get",
    params: query,
  });
}

export function getJourney(query) {
  return request({
    url: "/api/journey",
    method: "get",
    params: query,
  });
}
export function getPartener(query) {
  return request({
    url: "/api/partner",
    method: "get",
    params: query,
  });
}
export function getImages(query) {
  return request({
    url: "/api/image",
    method: "get",
    params: query,
  });
}



